import React, { useMemo } from 'react';

import { Alert, Divider } from 'antd';

import type { DataInsightsResponse } from '@/shared/api/openmetadata';
import { LoadingState } from '@/shared/ui/states/LoadingState';

import styles from './InsightsTab.module.css';
import { PlatformInsights } from './PlatformInsights';
import { TotalDataAssets } from './TotalDataAssets';

type AssetTypeCount = {
  type: string;
  count: number;
};

type InsightsTabProps = {
  insightsData?: DataInsightsResponse;
  totalAssets: number;
  assetTypeCounts?: AssetTypeCount[];
  isInsightsLoading?: boolean;
  isAssetsLoading?: boolean;
};

const InsightsTabComponent: React.FC<InsightsTabProps> = ({
  insightsData,
  totalAssets,
  assetTypeCounts = [],
  isInsightsLoading = false,
  isAssetsLoading = false,
}) => {
  const hasData = useMemo(() => {
    return insightsData && Object.keys(insightsData).length > 0;
  }, [insightsData]);

  if (isInsightsLoading || isAssetsLoading) {
    return <LoadingState message="인사이트 데이터를 불러오는 중..." />;
  }

  if (!hasData) {
    return (
      <div className={styles.insightsTab}>
        <Alert message="인사이트 데이터를 불러올 수 없습니다" type="info" showIcon />
      </div>
    );
  }

  return (
    <div className={styles.insightsTab}>
      <div className={styles.insightsRow}>
        <div className={styles.leftColumn}>
          <PlatformInsights
            assetsWithDescription={insightsData?.assets_with_description}
            assetsWithPii={insightsData?.assets_with_pii}
            assetsWithTier={insightsData?.assets_with_tier}
            assetsWithOwners={insightsData?.assets_with_owners}
          />
        </div>
        <Divider className={styles.divider} type="vertical" />
        <div className={styles.rightColumn}>
          <TotalDataAssets totalCount={totalAssets} assetTypeCounts={assetTypeCounts} isLoading={isAssetsLoading} />
        </div>
      </div>
    </div>
  );
};

export const InsightsTab = React.memo(InsightsTabComponent);
